import {
  UPDATE_MESSAGE_ATTR
} from '../action_types'

export default (containerId, messageId, attr, val) => {
  return {type: UPDATE_MESSAGE_ATTR, containerId, messageId, attr, val}
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/actions/update_message_attr.js
 **/